import axios from '@/libs/axios'

export default {
  fetchCabinetsForDropdown({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'dictionary/cabinet-for-dropdown/', method: 'GET', params })
        .then(res => {
          commit('SET_CABINETS_FOR_DROPDOWN', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  fetchDesignations({commit}) {
    return new Promise((resolve, reject) => {
      axios({ url: 'designations-scheduler/', method: 'GET' })
        .then(res => {
          commit('SET_DESIGNATIONS', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  editDesignation({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: `designations-scheduler/${data.id}/`, method: 'PATCH', data })
        .then(res => {
          commit('DESIGNATION_EDIT', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  addDesignation({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: 'designations-scheduler/', method: 'POST', data })
        .then(res => {
          commit('DESIGNATION_ADDED', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  removeDesignation({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: `designations-scheduler/${data.id}/`, method: 'DELETE' })
        .then(res => {
          commit('DESIGNATION_REMOVED', data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  fetchPatientsSchedule({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'scheduler-patient/', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  fetchPatientsScheduleByPeriod({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'scheduler-patient-by-period/', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  fetchCabinetsPatientsAppointments({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'scheduler-patient/', method: 'GET', params })
        .then(res => {
          commit('SET_CABINETS_APPOINTMENTS', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  addSchedulePatient({commit}, data) {
    const body = { ...data }
    body.birthday = body.birthday ? body.birthday : null
    return new Promise((resolve, reject) => {
      axios({ url: `scheduler-patient/`, method: 'POST', data: body })
        .then(res => {
          commit('schedulePatientAdded', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  getSchedulePatient({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: `scheduler-patient/${data.id}/`, method: 'GET', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  editSchedulePatient({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: `scheduler-patient/${data.id}/`, method: 'PATCH', data })
        .then(res => {
          commit('schedulePatientEdited', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  removeSchedulePatient({commit}, id) {
    return new Promise((resolve, reject) => {
      axios({ url: `scheduler-patient/${id}/`, method: 'DELETE' })
        .then(res => {
          commit('SCHEDULE_PATIENT_REMOVED', id)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  moveSchedulerPatient({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: 'move-scheduler-patient/', method: 'POST', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  abortSchedulerPatient({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `abort-scheduler-patient/${params.id}/`,
        method: 'DELETE',
        data: {
          abort_status_id: params.abort_status_id,
          cancellation_reason: params.cancellation_reason,
        }
      })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  fetchEmployeeSchedule({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'scheduler-employee/', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  createEmployeeSchedule({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: 'scheduler-employee/', method: 'POST', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  editEmployeeSchedule({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: `scheduler-employee/${data.id}/update`, method: 'PATCH', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  deleteEmployeeSchedule({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: `scheduler-employee/${data.id}/`, method: 'DELETE' })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  checkAppointmentsByEmployeeSchedulerId({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: `scheduler-employee/${params.id}/exist-appointment`, method: 'GET', params: params.query_params })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  checkCabinetIsFree({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `cabinet/${params.id}/is-free`, method: 'GET', params: params.query_params
      })
        .then(res => {
          resolve(res)
        }).catch(error => {
        reject({message: error})
      })
    })
  },
  fetchShifts({}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'work-shift/', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  editShift({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: `work-shift/${data.id}/`, method: 'PATCH', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  addShift({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: 'work-shift/', method: 'POST', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  fetchSchedulerDoctorsGroups({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'scheduler-doctors-groups/', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject({message: e}))
    })
  },
  fetchDoctorShiftsForAppointmentCalendar({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'doctor-shifts-for-appointment-calendar/', method: 'GET', params })
        .then(res => {
          commit('SET_DOCTOR_SHIFTS_FOR_APPOINTMENT_CALENDAR', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  deleteShift({commit}, id) {
    return new Promise((resolve, reject) => {
      axios({ url: `work-shift/${id}/`, method: 'DELETE' })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  fetchShiftCalendar({}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: `shift/${params.shiftId}/calendar`, method: 'GET', params: params.queryParams })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  moveItemToShift({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: `scheduler-calendar/${data.id}/move`, method: 'PATCH', data: data.bodyParams })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  fetchDoctorWeekendDate({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'weekends_doctors_groups/', method: 'GET', params })
        .then(res => {
          commit('setDoctorWeekendDates', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  fetchLoadingDoctors({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'workload-doctors/', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject({message: e}))
    })
  },
  fetchOfficeWorkload({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'office-workload/', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject({message: e}))
    })
  },
  fetchPatientsAwaitStatus({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `scheduler-patient-await-status/`, method: 'GET', params: params
      })
        .then(res => resolve(res))
        .catch(error => reject({message: error}))
    })
  },
  fetchPatientsOnlineStatus({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `scheduler-patient-online-status/`, method: 'GET', params: params
      })
        .then(res => resolve(res))
        .catch(error => reject({message: error}))
    })
  },
  fetchPatientsChangeStatus({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `scheduler-patient-change-status/`, method: 'GET', params: params
      })
        .then(res => resolve(res))
        .catch(error => reject({message: error}))
    })
  },
  // Reserves
  fetchReserves({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'scheduler-backup-visit-record/', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  addReserve({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: 'scheduler-backup-visit-record/', method: 'POST', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  editReserve({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: `scheduler-backup-visit-record/${data.id}/`, method: 'PATCH', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  deleteReserve({commit}, config) {
    return new Promise((resolve, reject) => {
      axios({ url: `scheduler-backup-visit-record/${config.data.id}/`, method: 'DELETE' })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  createPatientFromReserve({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: `scheduler-backup-visit-record-patient/${params.reserve_id}/`, method: 'PATCH', data: params.data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  requestAction({commit}, config) {
    return new Promise((resolve, reject) => {
      axios(config.request)
        .then(res => {
          if (config.hasOwnProperty('successCallback') && config.request.method !== 'DELETE') {
            config.successCallback(commit, res)
          }
          if (config.hasOwnProperty('successCallback') && config.request.method === 'DELETE') {
            config.successCallback(commit, config.request.data)
          }
          resolve(res)
        }).catch(error => {
        reject({message: error})
      })
    })
  },
  fetchCabinetsForUser({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: `cabinet_for_user/`, method: 'GET', params: params
      })
        .then(res => {
          commit('setCabinetsForUser', res.data)
          resolve(res)
        }).catch(error => {
        reject({message: error})
      })
    })
  },
  getAppointmentNoticesForUser({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: `user-appointment-notice/${data.userId}/`, method: 'POST', data: data.bodyParams })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  getWorkingDoctorsOnDay({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'working-doctors-on-day/', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  // Doctors for dropdown
  getDoctors({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'scheduler/doctor/', method: 'GET', params })
        .then(res => {
          commit('SET_DOCTORS', res.data)
          resolve(res)
        })
        .catch(e => reject({ message: e }))
    })
  },
  // Patient calendar free time
  fetchPatientCalendarFreeTime({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'patient-calendar-free-time/', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject( { message: e }))
    })
  },
  // Employee work day
  getEmployeeCurrentWorkDay() {
    return new Promise((resolve, reject) => {
      axios({
        url: `employee-current-work-day`,
        method: 'GET'
      })
        .then(res => resolve(res))
        .catch(e => reject({message: e}))
    })
  },
  startEmployeeWorkDay() {
    return new Promise((resolve, reject) => {
      axios({
        url: `employee-work-day/`,
        method: 'POST'
      })
        .then(res => resolve(res))
        .catch(e => reject({message: e}))
    })
  },
  updateEmployeeWorkDay({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({
        url: `employee-work-day/${data.id}/`,
        method: 'PATCH',
        data: data
      })
        .then(res => resolve(res))
        .catch(e => reject({message: e}))
    })
  },
  getEmployeeWorkDays({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({url: 'employee-work-day/', method: 'GET', params})
        .then(res => resolve(res))
        .catch(e => reject({message: e}))
    })
  },
  // Additional work shift
  addAdditionalWorkShift({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: 'additional-work-shift/', method: 'POST', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  editAdditionalWorkShift({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: `additional-work-shift/${data.id}/`, method: 'PATCH', data })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  removeAdditionalWorkShift({commit}, id) {
    return new Promise((resolve, reject) => {
      axios({ url: `additional-work-shift/${id}/`, method: 'DELETE' })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  // Cabinet doctors
  getCabinetDoctors({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'scheduler/cabinet/doctor/', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  // Doctor work schedule info by month for export to PDF
  getDoctorWorkScheduleInfoByMonth({commit}, data) {
    return new Promise((resolve, reject) => {
      axios({ url: `scheduler/doctor/${data.id}/work-schedule`, method: 'GET', params: data.queryParams })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  // All doctors work schedule info by month for export to PDF
  getAllDoctorsWorkScheduleInfoByMonth({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({ url: 'scheduler/doctors/work-schedule', method: 'GET', params })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
  // Get Excel file with all doctors work schedule info by month
  getExcelFileWithAllDoctorsWorkScheduleInfoByMonth({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: 'scheduler/doctors/work-schedule-export-excel', method: 'GET', params, responseType: 'blob'
      })
        .then(res => resolve(res))
        .catch(e => reject({ message: e }))
    })
  },
}
